const DECIMALS = 1e18;

const round = (n, decimals) => Math.round(n * (10 ** decimals)) / (10 ** decimals);

const toReadableNumber = (n) => round(n / DECIMALS, 2);
const toReadable = (n) => toReadableNumber(n).toLocaleString();
const toBlockchain = (n) => n * DECIMALS;

export { toReadable, toReadableNumber, toBlockchain };
